var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M27 2.604a11.515 11.515 0 0 1-3.19.877A5.517 5.517 0 0 0 26.247.413a11.043 11.043 0 0 1-3.51 1.344A5.54 5.54 0 0 0 18.692 0c-3.064 0-5.531 2.494-5.531 5.552 0 .44.037.864.128 1.266-4.602-.225-8.674-2.437-11.41-5.806a5.563 5.563 0 0 0 1.701 7.42 5.455 5.455 0 0 1-2.5-.685v.061a5.573 5.573 0 0 0 4.435 5.455 5.51 5.51 0 0 1-1.451.182 4.88 4.88 0 0 1-1.048-.094c.717 2.198 2.752 3.814 5.172 3.867a11.102 11.102 0 0 1-6.863 2.367c-.454 0-.89-.02-1.325-.076A15.551 15.551 0 0 0 8.492 22c10.185 0 15.754-8.462 15.754-15.796 0-.245-.008-.482-.02-.718A11.06 11.06 0 0 0 27 2.604z"}));
}

Twitter.defaultProps = {"width":"27","height":"22","viewBox":"0 0 27 22"};

module.exports = Twitter;

Twitter.default = Twitter;
